/**
 * Created by Ivan on 28.06.2026
 *
 */

const WeeklyGoalsHints = {};

WeeklyGoalsHints.collect_wands = function () {
    const allWands = Map2d.currentMap.listAvailableUnits({ code: "wands" });

    if (!allWands.length) {
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "UnitsLibraryWindow",
            action: function (f) {
                new UnitsLibraryWindow({ code: "wands", stage: 0 });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        return true;
    }

    const unit = allWands.find((u) => u.stage >= 2) || allWands[0];
    Map2d.currentMap.focusOnUnit(unit, {
        allowScrollWithFocus: true,
        skipFocusReport: true,
        callback: function () {
            if (unit.stage >= 2) {
                InfoView.DisplayInfo(unit);
                const unitView = unit.onGetView();
                const infoView = unitView && unitView.getAdditionalView("info");
                if (infoView) {
                    let button = null;
                    let queue = infoView.children.slice();
                    while (queue.length && !button) {
                        const node = queue.shift();
                        if (node.adviceTarget) {
                            button = node;
                        }
                        queue = queue.concat(node.children || []);
                    }
                    FingerView.hintTap(button || infoView, { runOnce: true });
                    return;
                }
            }
            FingerView.hintTap({ x: unit.x, y: unit.y }, { runOnce: true });
        }
    });
    return true;
};

WeeklyGoalsHints.use_shovels = function () {
    const icon = cleverapps.sideBar.findMissionIcon(Mission.TYPE_TREASURE_SEARCH);
    const iconView = icon && icon.onGetView && icon.onGetView();
    if (!iconView) {
        cleverapps.notification.create(Messages.get("WeeklyGoals.MissionNotStarted", { title: Messages.get("Missions.tsearch.Title") }));
        return false;
    }
    FingerView.hintTap(iconView, { runOnce: true, delay: 2 });
    return true;
};

WeeklyGoalsHints.complete_order = function () {
    const ordersItem = cleverapps.toolbar.getItem(ToolbarItem.ORDERS.type);
    const ordersView = ordersItem && ordersItem.onGetView();
    if (!ordersView || !ordersView.isVisible()) {
        return false;
    }
    FingerView.hintTap(ComponentUtils.findChildByName(ordersView, "content"), { runOnce: true });
    return true;
};
